import { type Client, OpenFeature } from '@openfeature/web-sdk';

import {
  HARNESS_OPENFEATURE_DOMAIN,
  HARNESS_ORG_OPENFEATURE_DOMAIN,
} from '../providers/harnessProvider';
import type { FeatureFlagProvider } from './featureFlagClient.types';

const DEFAULT_PROVIDER: FeatureFlagProvider = 'harness';

const providerDomains: Record<FeatureFlagProvider, string> = {
  harness: HARNESS_OPENFEATURE_DOMAIN,
  harnessWithOrgIdTargetingKey: HARNESS_ORG_OPENFEATURE_DOMAIN,
};

export function normalizeFeatureFlagProvider(provider?: FeatureFlagProvider): FeatureFlagProvider {
  switch (provider) {
    case 'harness':
      return 'harness';
    case 'harnessWithOrgIdTargetingKey':
      return 'harnessWithOrgIdTargetingKey';
    case undefined:
      // Legacy bridge calls omit the provider; they now evaluate on Harness.
      return DEFAULT_PROVIDER;
    default:
      throw new Error(`[FeatureFlags] Unsupported provider: ${String(provider)}`);
  }
}

export function getFeatureFlagClient(provider?: FeatureFlagProvider): Client {
  return OpenFeature.getClient(providerDomains[normalizeFeatureFlagProvider(provider)]);
}
